
import WeatherSelect from './WeatherSelect';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import WeatherDateSlider from './WeatherDateSlider';

const WeatherTools = () => {
    return (
        <>
            <Accordion className='accordion-style' defaultExpanded>
                <AccordionSummary
                    className='accordion-title'
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="Date Slider"
                    id="Date"
                >
                    <label id='TimePicker' htmlFor='TimePicker'>Date</label>
                    
                </AccordionSummary>
                <AccordionDetails>
                    <div style={{ width: '94%' }}>
                        <WeatherDateSlider/>
                    </div>
                </AccordionDetails>
            </Accordion>
            <Accordion className='accordion-style' defaultExpanded>
                <AccordionSummary
                    className='accordion-title'
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="Weather"
                    id="Weather"
                >
                    <label id='weatherData' htmlFor='weatherData'>Weather Data</label>
                </AccordionSummary>
                <AccordionDetails>
                    <WeatherSelect/>
                </AccordionDetails>
            </Accordion>

        </>
    )
}

export default WeatherTools;
